import { render, staticRenderFns } from "./Service_Setup_Dialog.vue?vue&type=template&id=72fb5b30&scoped=true"
import script from "./Service_Setup_Dialog.vue?vue&type=script&lang=js"
export * from "./Service_Setup_Dialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72fb5b30",
  null
  
)

export default component.exports